import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableModule } from 'primeng/table';
import { SharedModule } from 'app/shared/shared.module';
import { LicensesLayoutComponent } from 'app/licenses/overview/layout/licenses-layout.component';
import { LicensesComponent } from 'app/licenses/overview/overview/licenses-overview.component';
import { LicenseFacade } from 'app/shared/services/facades/license.facade';
import { LicenseService } from '../shared/services/license.service';
import { LicensesSidepanelComponent } from 'app/licenses/overview/sidepanel/licenses-sidepanel.component';
import { LicenseDetailsGeneralComponent } from 'app/licenses/details/license-details-general.component';
import { LicenseDetailsComponent } from 'app/licenses/details/license-details.component';
import { LicenseEntityResolver } from 'app/shared/components/entity-resolvers/license.entity-resolver';
import { LicensesNavigatorHelper } from 'app/licenses/licenses-navigator-helper';
import { LicenseDetailsUsersComponent } from 'app/licenses/details/license-details-users.component';
import { LicensesRoutingModule } from './licenses-routing.module';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    LicensesLayoutComponent,
    LicensesSidepanelComponent,
    LicensesComponent,
    LicenseDetailsComponent,
    LicenseDetailsGeneralComponent,
    LicenseDetailsUsersComponent,
  ],
  imports: [CommonModule, SharedModule, TableModule, LicensesRoutingModule, FormsModule],
  exports: [
    LicensesLayoutComponent,
    LicensesSidepanelComponent,
    LicensesComponent,
    LicenseDetailsComponent,
    LicenseDetailsGeneralComponent,
    LicenseDetailsUsersComponent,
  ],
  providers: [LicenseFacade, LicenseService, LicenseEntityResolver, LicensesNavigatorHelper],
})
export class LicensesModule {}
